import { defineComponent as _defineComponent } from 'vue'
import objectFitImages from 'object-fit-images'
import { computed, onMounted, watch, ref } from 'vue'

interface Props {
    icon: string
    size?: string
    title?: string | null
    default?: boolean
    list?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'person-avatar',
  props: {
    icon: null,
    size: { default: '48px' },
    title: { default: null },
    default: { type: Boolean, default: false },
    list: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { icon: string, size: string, title: string | null, default: boolean, list: boolean }



const alt = computed(() => {
    return props.title
        ? 'Avatar: ' + props.title
        : null
})

const avatar = ref(null)

onMounted(() => objectFitImages(avatar.value))

watch(() => props.icon, () => objectFitImages(avatar.value))

return { __sfc: true,props, alt, avatar }
}

})